import { z } from "zod"

z.config({
  customError: (iss) => {
    switch (iss.code) {
      case "invalid_type":
        return "Required"
      case "too_small":
        if (iss.origin === "string" && iss.minimum === 1) return "Required"
        if (iss.origin === "array" && iss.minimum === 1) return "Required"
        return undefined
      case "invalid_format":
        if (iss.format === "email") return "Please enter a valid email"
        return undefined
      default:
        return undefined
    }
  },
})
